var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"tag-pill tag-default",attrs:{"to":""}},[_vm._v(_vm._s(_vm.tag))])}
var staticRenderFns = []

export { render, staticRenderFns }